import { render } from "./BackToTimelineButton.vue?vue&type=template&id=1fc03052&scoped=true"
import script from "./BackToTimelineButton.vue?vue&type=script&lang=js"
export * from "./BackToTimelineButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc03052"]])

export default __exports__